var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WithDisposable } from '@blocksuite/lit';
import { flip, offset } from '@floating-ui/dom';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { createLitPortal } from '../../_common/components/portal.js';
import { MoreIcon } from '../../_common/icons/index.js';
import { BookmarkOperationMenu } from './bookmark-operation-popper.js';
import { config, } from './config.js';
let BookmarkToolbar = class BookmarkToolbar extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this._moreMenuAbortController = null;
    }
    _toggleMenu() {
        if (this._moreMenuAbortController) {
            this._moreMenuAbortController.abort();
            this._moreMenuAbortController = null;
            return;
        }
        this._moreMenuAbortController = new AbortController();
        const bookmarkOperationMenu = new BookmarkOperationMenu();
        bookmarkOperationMenu.model = this.model;
        bookmarkOperationMenu.onSelected = this.onSelected;
        bookmarkOperationMenu.std = this.std;
        createLitPortal({
            template: bookmarkOperationMenu,
            container: this.bookmarkBarElement,
            computePosition: {
                referenceElement: this.bookmarkBarElement,
                placement: 'top-end',
                middleware: [flip(), offset(4)],
                autoUpdate: true,
            },
            abortController: this._moreMenuAbortController,
        });
    }
    render() {
        const buttons = repeat(config.filter(({ showWhen = () => true }) => showWhen(this.model)), ({ type }) => type, ({ type, icon, tooltip, action, divider, disableWhen = () => false }) => {
            return html `<icon-button
            size="32px"
            class="bookmark-toolbar-button ${type}"
            ?disabled=${disableWhen(this.model)}
            @click=${() => {
                action(this.model, this.onSelected, this);
            }}
          >
            ${icon}
            <affine-tooltip .offset=${12}>${tooltip}</affine-tooltip>
          </icon-button>
          ${divider ? html `<div class="divider"></div>` : nothing} `;
        });
        return html `
      <div class="bookmark-bar">
        ${buttons}

        <div class="more-button-wrapper">
          <icon-button
            size="24px"
            class="more-button"
            @click=${() => {
            this._toggleMenu();
        }}
          >
            ${MoreIcon}
            <affine-tooltip .offset=${12}>More</affine-tooltip>
          </icon-button>
        </div>
      </div>
    `;
    }
};
BookmarkToolbar.styles = css `
    .bookmark-bar {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 8px;
      gap: 8px;
      height: 40px;

      border-radius: 8px;
      background: var(--affine-background-overlay-panel-color);
      box-shadow: var(--affine-shadow-2);
      user-select: none;
    }
    .divider {
      width: 1px;
      height: 24px;
      background-color: var(--affine-border-color);
    }
  `;
__decorate([
    property({ attribute: false })
], BookmarkToolbar.prototype, "model", void 0);
__decorate([
    property({ attribute: false })
], BookmarkToolbar.prototype, "onSelected", void 0);
__decorate([
    property({ attribute: false })
], BookmarkToolbar.prototype, "host", void 0);
__decorate([
    property({ attribute: false })
], BookmarkToolbar.prototype, "abortController", void 0);
__decorate([
    query('.bookmark-bar')
], BookmarkToolbar.prototype, "bookmarkBarElement", void 0);
__decorate([
    query('.more-button-wrapper')
], BookmarkToolbar.prototype, "moreButton", void 0);
__decorate([
    property({ attribute: false })
], BookmarkToolbar.prototype, "std", void 0);
BookmarkToolbar = __decorate([
    customElement('bookmark-toolbar')
], BookmarkToolbar);
export { BookmarkToolbar };
//# sourceMappingURL=bookmark-toolbar.js.map